module.exports = __webpack_public_path__ + "img/boards-coin.654699d.webp";